import { FunctionComponent, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Location, useNavigate, useSearchParams } from 'react-router-dom';
import AppContext from 'src/AppContext';
import { organizationPaths } from 'src/routes';
import { isLicenseSystemIdFormatValid } from '../system-licences/LicenseManagement';

export interface NavigatorProps {
    isTemporaryLicensesRequest: boolean;
};

interface CustomNavigationState {
    redirectedFromAppService: boolean;
    isTemporaryLicensesRequest: boolean;
    licenseSystemId: string;
}
export interface LocationWithCustomState extends Omit<Location, 'state'> {
    state: CustomNavigationState;
}

const RedirectToLicenseManagement: FunctionComponent<NavigatorProps> = ({ isTemporaryLicensesRequest }) => {
    const { t } = useTranslation();
    const context = useContext(AppContext);
    const navigate = useNavigate();
    const searchParams = useSearchParams()[0];
    const licenseSystemId = searchParams.get('id')!;

    const isFormatValid = isLicenseSystemIdFormatValid(licenseSystemId);
    const routeState = {
        redirectedFromAppService: true,
        ...(isFormatValid && { isTemporaryLicensesRequest, licenseSystemId }),
    };

    useEffect(() => {
        if (context.user === undefined) return;

        if (!isFormatValid) {
            context.onShowModal('infoModal', {
                title: t('LicenceManagement.id_validation_error_title', 'Validation error'),
                content: <div>{t('LicenceManagement.id_validation_error_description', 'The license system serial number does not match the required format.')}</div>,
            });
        }

        navigate(organizationPaths.systemLicences(context.user!.orgId!), { state: routeState });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [context.user]);

    return (null);
};

export default RedirectToLicenseManagement;
